import React from "react";
import "../App.css";
import truck from "../images/truck.png";
import report from '../images/report.png';
import route  from "../images/route.png";

const ProcessSection = () => {
  return (
    <div className="process-container">
      <div className="process-header">
        <span className="process-subtitle">SÜRECİMİZ</span>
        <h2 className="process-title">DMNGL Nakliyat Çalışma Süreci</h2>
        <a 
          href="https://wa.me/905352439955?text=Merhaba,%20nakliyat%20fiyatı%20almak%20istiyorum." 
          target="_blank" 
          rel="noopener noreferrer"
          className="quote-button"
          style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
        >
          Fiyat Talep Et &rarr;
        </a>
      </div>

      <div className="process-steps">
        <div className="step">
          <span className="step-number">01</span>
          <div className="step-content">
            <div className="step-icon">
              <img src={route} alt="Planlama" />
            </div>
            <h3>İletişim & Planlama</h3>
            <p>
              Bize ulaştığınız anda eşyalarınızın miktarı ve konumu belirlenir; size en uygun araç ve fiyat planlaması yapılır.
            </p>
            <a href="https://wa.me/905352439955" className="read-more">→</a>
          </div>
        </div>

        <div className="step">
          <span className="step-number">02</span>
          <div className="step-content">
            <div className="step-icon">
              <img src={truck} alt="Yükleme" />
            </div>
            <h3>Özenli Yükleme</h3>
            <p>
              Uzman ekibimiz eşyalarınızı titizlikle paketler ve araçlarımıza güvenli bir şekilde istifleyerek yükler.
            </p>
            <a href="https://wa.me/905352439955" className="read-more">→</a>
          </div>
        </div>

        <div className="step">
          <span className="step-number">03</span>
          <div className="step-content">
            <div className="step-icon">
              <img src={report} alt="Teslimat" />
            </div>
            <h3>Güvenli Teslimat</h3>
            <p>
              Yeni adresinize taşınan eşyalarınız, hiçbir zarar görmeden hızlı ve zamanında yerine ulaştırılarak teslim edilir.
            </p>
            <a href="https://wa.me/905352439955" className="read-more">→</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessSection;